/**
 * PayPal Configuration (frontend)
 *
 * The frontend only ever needs the public Client ID — it renders the PayPal
 * buttons and lets PayPal's own SDK collect payment. Order creation and
 * capture (which need the PayPal Secret) happen in Cloud Functions
 * (functions/index.js), never here.
 *
 * Setup:
 * 1. Create a PayPal app at developer.paypal.com (Sandbox first, Live later)
 * 2. Add to your root .env file:
 *      REACT_APP_PAYPAL_CLIENT_ID=your_sandbox_client_id
 *      REACT_APP_PAYPAL_ENVIRONMENT=sandbox
 */

export const PAYPAL_CONFIG = {
  clientId: process.env.REACT_APP_PAYPAL_CLIENT_ID || "",
  environment: process.env.REACT_APP_PAYPAL_ENVIRONMENT || "sandbox", // "sandbox" or "live"
};

export const validatePayPalConfig = () => {
  if (!PAYPAL_CONFIG.clientId) {
    console.warn(
      "⚠️  PayPal Client ID not configured. Add REACT_APP_PAYPAL_CLIENT_ID to .env"
    );
    return false;
  }
  return true;
};

export default PAYPAL_CONFIG;
